import { useContext } from 'react';
import { ToastContext } from './ToastContext';
import { Toast } from '@shopify/app-bridge-react';

export const ToastElement = () => {
  const { toastState, setToastState } = useContext(ToastContext);

  const handleHideToast = () => setToastState({
    ...toastState,
    show: false
  });

  const toastMarkup = toastState.show && (
    <Toast
      content={toastState.content}
      onDismiss={handleHideToast}
      duration={toastState.duration}
      error={toastState.isError}
    />
  );

  return <>
    {toastMarkup}
  </>;
}